import type { PipeCard } from '@/shared/api/resources';
import { formatCpfCnpj } from '@/shared/lib/format';

/** Menos que isso acha quase tudo e nao ajuda a localizar nada. */
export const TAMANHO_MINIMO_DA_BUSCA = 3;

/**
 * Endereco do quadro com a busca aplicada e, quando ha, o cartao aberto. O quadro le `q`
 * e `cartao` do endereco (PipeBoardPage).
 */
export function caminhoDoCartao(
  pipeId: string,
  busca: string,
  cardId?: string,
): string {
  const parametros = new URLSearchParams();
  if (busca) parametros.set('q', busca);
  if (cardId) parametros.set('cartao', cardId);
  const texto = parametros.toString();
  return `/esteiras/${pipeId}${texto ? `?${texto}` : ''}`;
}

function parte(
  rotulo: string,
  nome: string | undefined,
  documento?: string,
): string | null {
  if (!nome) return null;
  return documento
    ? `${rotulo}: ${nome} (${formatCpfCnpj(documento)})`
    : `${rotulo}: ${nome}`;
}

/** O que a lista de achados mostra de cada cartao: titulo e as partes. */
export function resumoDoCartao(cartao: PipeCard): { titulo: string; linhas: string[] } {
  const operacao = cartao.operation;
  if (operacao) {
    const numero = operacao.proposal_number || 'sem numero';
    return {
      titulo: `Cotacao ${numero} · Operacao ${operacao.number}`,
      linhas: [
        parte('Tomador', operacao.policyholder.label, operacao.policyholder.document),
        parte('Corretora', operacao.broker?.label),
        parte('Modalidade', operacao.modality),
        operacao.subject ? `Objeto: ${operacao.subject}` : null,
      ].filter((linha): linha is string => linha !== null),
    };
  }
  const sujeito = cartao.subject;
  return {
    titulo: cartao.title,
    linhas: sujeito
      ? [
          parte('Tomador', sujeito.policyholder.label, sujeito.policyholder.document),
          parte('Corretora', sujeito.broker?.label),
        ].filter((linha): linha is string => linha !== null)
      : [],
  };
}
